export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE'

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE'

export const REFRESH_TOKEN_PROMPT_REQUEST = 'REFRESH_TOKEN_PROMPT_REQUEST'
export const REFRESH_TOKEN_PROMPT_SUCCESS = 'REFRESH_TOKEN_PROMPT_SUCCESS'
export const REFRESH_TOKEN_PROMPT_FAILURE = 'REFRESH_TOKEN_PROMPT_FAILURE'

export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE'

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE'

export const VERIFY_DEVICE_REQUEST = 'VERIFY_DEVICE_REQUEST'
export const VERIFY_DEVICE_SUCCESS = 'VERIFY_DEVICE_SUCCESS'
export const VERIFY_DEVICE_FAILURE = 'VERIFY_DEVICE_FAILURE'

export const VERIFY_RESET_REQUEST = 'VERIFY_RESET_REQUEST'
export const VERIFY_RESET_SUCCESS = 'VERIFY_RESET_SUCCESS'
export const VERIFY_RESET_FAILURE = 'VERIFY_RESET_FAILURE'

export const VERIFY_INVITATION_REQUEST = 'VERIFY_INVITATION_REQUEST'
export const VERIFY_INVITATION_SUCCESS = 'VERIFY_INVITATION_SUCCESS'
export const VERIFY_INVITATION_FAILURE = 'VERIFY_INVITATION_FAILURE'
